import {
  Card,
  CardMedia,
  Carousel,
  CarouselItem,
  Grid,
  GridItem,
  Typography
} from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';

export default function AccessoryEntrancesSkeleton() {
  const { t } = useTranslation('webshop');
  const carouselTranslations = useFreddyTranslations('carousel');

  return (
    <>
      <Typography variant='h2' mb={400}>
        {t('productPage.suitableAccessories')}
      </Typography>
      <Grid gap={400} hideUntil='md'>
        {[...Array(4)].map((_, i) => (
          <GridItem column={{ md: 'span 3' }} key={i}>
            <AccessoryCategoryCardSkeleton />
          </GridItem>
        ))}
      </Grid>
      <Carousel
        hideFrom='md'
        itemsInView={{
          xs: 1.5,
          sm: 2.4
        }}
        hideNavigation
        fullWidthUntil='md'
        translations={carouselTranslations}
      >
        {[...Array(4)].map((_, i) => (
          <CarouselItem key={i}>
            <AccessoryCategoryCardSkeleton />
          </CarouselItem>
        ))}
      </Carousel>
    </>
  );
}

function AccessoryCategoryCardSkeleton() {
  return (
    <Card fullHeight header={<CardMedia padding={300} />} title={<span hidden>loading ...</span>} />
  );
}
